import React from "react";
import EbDialog from "../../../ExecutionBlueprint/ExecutionBlueprintLiveReview/_shared/EbDialog";
import "../../_shared/_qokr-warn-panel.scss";

// "Lock this quarter's OKRs?" — from `qokr_lr_lock_preflight` (§10). Blocked
// while any to-discuss objective isn't marked discussed; the rest warns.
const WarnList = ({ title, items, text }) =>
  items?.length ? (
    <div className="qokr-warn-panel">
      <div className="qokr-warn-panel__head">
        <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
        {title}
      </div>
      <ul className="qokr-warn-panel__list">
        {items.map((item) => (
          <li key={item.user_id}>{text(item)}</li>
        ))}
      </ul>
    </div>
  ) : null;

const LiveLockDialog = ({ preflight, locking, onLock, onClose }) => {
  const blocking = preflight?.blocking?.to_discuss_not_discussed || [];
  const warnings = preflight?.warnings || {};

  return (
    <EbDialog
      isOpen
      size="md"
      tone="primary"
      icon={<i className="fa-solid fa-lock" aria-hidden="true" />}
      title="Lock this quarter's OKRs?"
      busy={locking}
      onClose={onClose}
      actions={[
        { label: "Cancel", variant: "ghost", onClick: onClose },
        {
          label: "Lock OKRs",
          loadingLabel: "Locking…",
          variant: "primary",
          loading: locking,
          disabled: !preflight?.can_lock,
          onClick: onLock,
        },
      ]}
    >
      <p>
        Locking makes these the quarter&apos;s OKRs for everyone. Weekly scoring
        starts, and they appear in WRAP and the weekly meeting.
      </p>
      {!preflight ? <p className="mb-0">Checking the agenda…</p> : null}
      {blocking.length ? (
        <div className="qokr-warn-panel qokr-warn-panel--block">
          <div className="qokr-warn-panel__head">
            <i className="fa-solid fa-comment-dots" aria-hidden="true" />
            Still to discuss
          </div>
          <ul className="qokr-warn-panel__list">
            {blocking.map((item) => (
              <li key={`${item.type}:${item.objective_id}`}>
                {item.member ? `${item.member.name} · ` : ""}
                {item.objective}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      <WarnList
        title="Owners who are deactivated"
        items={warnings.deactivated_owners}
        text={(item) => item.name}
      />
      <WarnList
        title="People without an objective"
        items={warnings.members_without_objective}
        text={(item) => item.name}
      />
      <WarnList
        title="Owners without an individual objective for what they own"
        items={warnings.owners_without_individual_objective}
        text={(item) => item.name}
      />
    </EbDialog>
  );
};

export default LiveLockDialog;
